import React from "react";
import waveBg from "../../assets/images/whitebackground.jpg"; // ✅ apne path ke hisaab se change karo

const testimonials = [
  {
    id: 1,
    name: "Rahul Sharma",
    role: "Business Owner",
    img: "https://randomuser.me/api/portraits/men/32.jpg",
    text: "Code Infra Technologies developed a modern and professional website for my business. Their team understood my requirements clearly and delivered a design that perfectly represents my brand. The communication and support throughout the project were excellent.",
  },
  {
    id: 2,
    name: "Neha Kapoor",
    role: "Entrepreneur",
    img: "https://randomuser.me/api/portraits/women/44.jpg",
    text: "My old website looked outdated and was not performing well. Code Infra Technologies redesigned it with a fresh and responsive layout. Now it looks professional and my clients find it much easier to navigate.",
  },
  {
    id: 3,
    name: "Karan Malhotra",
    role: "Startup Founder",
    img: "https://randomuser.me/api/portraits/men/55.jpg",
    text: "Working with Code Infra Technologies was a great experience. They delivered the project on time and ensured every feature worked smoothly. Their attention to detail and dedication to quality impressed me the most.",
  },
  {
    id: 4,
    name: "Pooja Sharma",
    role: "Marketing Manager",
    img: "https://randomuser.me/api/portraits/women/68.jpg",
    text: "The team at Code Infra Technologies built a clean and responsive website for our company. They were professional, supportive, and always ready to make improvements whenever required.",
  },
  {
    id: 5,
    name: "Aman Verma",
    role: "Business Consultant",
    img: "https://randomuser.me/api/portraits/men/76.jpg",
    text: "I really appreciate the creativity and technical expertise of Code Infra Technologies. They transformed my ideas into a fully functional website that looks amazing and works perfectly on all devices.",
  },
  {
    id: 6,
    name: "Simran Kaur",
    role: "Small Business Owner",
    img: "https://randomuser.me/api/portraits/women/12.jpg",
    text: "Code Infra Technologies provided excellent service from start to finish. Their team helped me create a website that truly reflects my business and has received great feedback from my customers.",
  },
];

export default function TestimonialSection() {
  return (
    <>
      <section
        className="testimonial-section"
        style={{
          backgroundImage: `url(${waveBg})`,
        }}
      >
        <div className="testimonial-container">
          <h2 className="testimonial-title">
            See what our customers
            <br />
            <span>are saying...</span>
          </h2>

          <div className="testimonial-grid">
            {testimonials.map((item) => (
              <div key={item.id} className="testimonial-card">
                <div className="testimonial-header">
                  {/* <img src={item.img} alt={item.name} /> */}
                  <div>
                    <h4>{item.name}</h4>
                    <p>{item.role}</p>
                  </div>
                </div>

                <p className="testimonial-text">{item.text}</p>
                <div className="stars">★★★★★</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* INTERNAL CSS */}
      <style>{`
        .testimonial-section {
          width: 100%;
          padding: 80px 20px;
          background-color: #f7f7f7;
          background-repeat: no-repeat;
          background-position: bottom;
          background-attachment: fixed;
          background-size: cover;
        }

        .testimonial-container {
          max-width: 1200px;
          margin: auto;
          text-align: center;
        }

        .testimonial-title {
          font-size: 32px;
          font-weight: 700;
          color: #333;
          margin-bottom: 50px;
        }

        .testimonial-title span {
          color: #2aa198;
          border-bottom: 3px solid #2aa198;
        }

        .testimonial-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 25px;
        }

        .testimonial-card {
          background: #fff;
          padding: 25px;
          border-radius: 12px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.08);
          text-align: left;
          transition: 0.3s ease;
        }

        .testimonial-card:hover {
          transform: translateY(-6px);
        }

        .testimonial-header {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 15px;
        }

        .testimonial-header img {
          width: 55px;
          height: 55px;
          border-radius: 50%;
          object-fit: cover;
        }

        .testimonial-header h4 {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
        }

        .testimonial-header p {
          margin: 0;
          font-size: 13px;
          color: #777;
        }

        .testimonial-text {
          font-size: 14px;
          color: #666;
          line-height: 1.6;
          margin-bottom: 15px;
        }

        .stars {
          color: #ffc107;
          font-size: 16px;
        }

        @media (max-width: 992px) {
          .testimonial-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 576px) {
          .testimonial-title {
            font-size: 24px;
          }

          .testimonial-grid {
            grid-template-columns: 1fr;
          }

          .testimonial-section {
            padding: 60px 15px;
            background-attachment: scroll;
          }
        }
      `}</style>
    </>
  );
}